import { apiHelper } from "../redux/apiHelper";

// Get all subscriptions list (Admin)
export const getSubscriptions = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    if (params.package) queryParams.append('package', params.package);
    if (params.search) queryParams.append('search', params.search);
    if (params.isRecurring !== undefined) queryParams.append('isRecurring', params.isRecurring);

    const queryString = queryParams.toString();
    const url = `/api/admin/subscription${queryString ? `?${queryString}` : ''}`;
    
    let res = await apiHelper("get", url);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Get single subscription by ID
export const getSubscriptionById = async (id) => {
  try {
    let res = await apiHelper("get", `/api/admin/subscription/${id}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Create subscription (Admin)
export const createSubscription = async (data) => {
  try {
    let res = await apiHelper("post", `/api/admin/subscription/create`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Update subscription (Admin)
export const updateSubscription = async (id, data) => {
  try {
    let res = await apiHelper("post", `/api/admin/subscription/update/${id}`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Delete subscription (Admin)
export const deleteSubscription = async (id) => {
  try {
    let res = await apiHelper("delete", `/api/admin/subscription/delete/${id}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

